import React, { Dispatch, SetStateAction } from 'react'
import { Box, Stack, Typography } from '@mui/material'
import { FormattedMessage, useIntl } from 'react-intl'
import Popup from '../../../../components/Popup'
import { Form } from 'react-final-form'
import ButtonDefault from '../../../../components/ButtonDefault'
import { useHistory } from 'react-router-dom'
import { MAIN_PATH, SECONDARY_PATH } from '../../../../constant/path'
import { SEND_DOCUMENTS_FIELDS_VALUES } from '../services/dashboardConstants'
import { useBreakpoints } from '../../../../components/breakpoints/BreakpointsProvider'
import RadioInput from '../../../../components/form/RadioInput'
import { SOCIAL_SECURITY_CHOICES } from '../../personalInfo/services/personalInfoConstants'

type SendOtherDocumentPopupProps = {
	open: boolean
	setOpen: Dispatch<SetStateAction<boolean>>
}

const SendOtherDocumentPopup: React.FC<SendOtherDocumentPopupProps> = (
	{
		open,
		setOpen
	}
) => {
	const intl = useIntl()
	const history = useHistory()
	const { isMobile, height } = useBreakpoints()

	const SELECT_DATA = [
		{
			value: SEND_DOCUMENTS_FIELDS_VALUES.GEREP_MUTUELLE,
			label: intl.formatMessage({ id: 'dashboard.sendDocuments.popup.labels.gerepMutuelle' })
		},
		{
			value: SEND_DOCUMENTS_FIELDS_VALUES.BIRTH_CERTIFICATE,
			label: intl.formatMessage({ id: 'dashboard.sendDocuments.popup.labels.acteNaissance' })
		},
		{
			value: SEND_DOCUMENTS_FIELDS_VALUES.ATTESTATION_SS,
			label: intl.formatMessage({ id: 'dashboard.sendDocuments.popup.labels.attestationSS' })
		},
		{
			value: SEND_DOCUMENTS_FIELDS_VALUES.POLE_EMPLOI,
			label: intl.formatMessage({ id: 'dashboard.sendDocuments.popup.labels.poleEmploi' })
		},
		{
			value: SEND_DOCUMENTS_FIELDS_VALUES.CERTIFICAT_RADIATION,
			label: intl.formatMessage({ id: 'dashboard.sendDocuments.popup.labels.certificatRadiation' })
		},
		{
			value: SEND_DOCUMENTS_FIELDS_VALUES.CERTIFICAT_SCOLARITE,
			label: intl.formatMessage({ id: 'dashboard.sendDocuments.popup.labels.certificatScolarite' })
		},
		{
			value: SEND_DOCUMENTS_FIELDS_VALUES.FACTURE,
			label: intl.formatMessage({ id: 'dashboard.sendDocuments.popup.labels.facture' })
		},
		{
			value: SEND_DOCUMENTS_FIELDS_VALUES.PRELEVEMENT,
			label: intl.formatMessage({ id: 'dashboard.sendDocuments.popup.labels.prelevement' })
		},
		{
			value: SEND_DOCUMENTS_FIELDS_VALUES.RELEVE_SECU,
			label: intl.formatMessage({ id: 'dashboard.sendDocuments.popup.labels.releveSS' })
		}
	]

	const onSubmit = (values: any) => {
		switch (values?.sendDocumentSelect) {
			case SEND_DOCUMENTS_FIELDS_VALUES.POLE_EMPLOI:
				history.push(SECONDARY_PATH.SERVICES_EXTEND_COVER)
				break
			case SEND_DOCUMENTS_FIELDS_VALUES.CERTIFICAT_SCOLARITE:
				history.push(SECONDARY_PATH.SERVICES_ADULT_CHILDREN)
				break
			case SEND_DOCUMENTS_FIELDS_VALUES.AUTRE:
				history.push(MAIN_PATH.HELP)
				break
			case SEND_DOCUMENTS_FIELDS_VALUES.FACTURE:
			case SEND_DOCUMENTS_FIELDS_VALUES.RELEVE_SECU:
			case SEND_DOCUMENTS_FIELDS_VALUES.RELEVE_AUTRE:
				history.push(SECONDARY_PATH.REFUND_DEMAND)
				break
			case SEND_DOCUMENTS_FIELDS_VALUES.DEVIS:
				history.push(SECONDARY_PATH.SERVICES_SEND_QUOTE)
				break
			case SEND_DOCUMENTS_FIELDS_VALUES.BIRTH_CERTIFICATE:
				history.push({ pathname: MAIN_PATH.HELP, state: { birthCertificate: true } })
				break
			case SEND_DOCUMENTS_FIELDS_VALUES.ATTESTATION_SS:
			case SEND_DOCUMENTS_FIELDS_VALUES.CERTIFICAT_RADIATION:
			case SEND_DOCUMENTS_FIELDS_VALUES.GEREP_MUTUELLE:
				history.push({
					pathname: SECONDARY_PATH.CONNEXION_NOEMIE,
					state: { option: SEND_DOCUMENTS_FIELDS_VALUES.ATTESTATION_SS === values?.sendDocumentSelect ? SOCIAL_SECURITY_CHOICES.TRANSMETTRE_SS : SOCIAL_SECURITY_CHOICES.GEREP_MUTUELLE }
				})
				break
			case SEND_DOCUMENTS_FIELDS_VALUES.PRELEVEMENT:
				history.push(SECONDARY_PATH.MANDAT_PRELEVEMENT)
				break
			default:
				break
		}
		setOpen(false)
	}

	return (
		<Popup
			width={!isMobile ? '448px' : 'auto'}
			open={open}
			setOpen={setOpen}
			title={intl.formatMessage({ id: 'dashboard.sendDocuments.popup.title' })}
			overflowHidden
		>
			<Form
				onSubmit={onSubmit}
				render={({ handleSubmit, pristine }) => (
					<form onSubmit={handleSubmit} style={{ width: '100%', display: 'flex', flexDirection: 'column', maxHeight: height - 280 }}>
						<Stack
							direction="column"
							spacing="24px"
							sx={{
								flex: 1,
								overflowY: 'auto',
								paddingRight: '8px'
							}}
						>
							<Typography variant="body2">
								<FormattedMessage id="dashboard.sendDocuments.popup.text" />
							</Typography>

							<RadioInput name="sendDocumentSelect" data={SELECT_DATA} />
						</Stack>

						<Box
							display="flex"
							justifyContent="center"
							padding={1}
							sx={{
								backgroundColor: 'white',
								borderTop: '1px solid #e0e0e0',
								position: 'sticky',
								bottom: 0,
								zIndex: 1,
								height: '30px'
							}}
						>
							<ButtonDefault
								fullWidth={isMobile}
								variant="contained"
								type="submit"
								disabled={pristine}
							>
								<FormattedMessage id="global.button.continue" />
							</ButtonDefault>
						</Box>
					</form>
				)}
			/>
		</Popup>
	)
}

export default SendOtherDocumentPopup